import { useCallback, useMemo } from 'react'
import { dataUnready } from '~/lib/helpers/dataUnready'
import { formatAlert } from '~/lib/helpers/formatAlert'
import PropTypes from 'prop-types'

// Static alert model
const ALERT_MODEL = {
  title: '{count} mySCP Connect (notification|notifications)',
  url: 'https://connect.myscp.com/'
}

function AlertsItem ({ count, handleAlertClick, tag: Tag }) {
  const formattedAlert = useMemo(() => formatAlert({ count }, ALERT_MODEL), [count])

  const handleClick = useCallback(() => {
    handleAlertClick(formattedAlert.url)
  }, [handleAlertClick])

  return (
    <Tag title={formattedAlert.title} handleClick={handleClick} />
  )
}

function MyScpAlerts ({ data, tag, handleAlertClick }) {
  const { unready, myscpUserMetadata } = dataUnready(data, 'myscpUserMetadata')
  let results = null

  if (!unready) {
    if (myscpUserMetadata && myscpUserMetadata.unreadMessageCount > 0) {
      results = <AlertsItem count={myscpUserMetadata.unreadMessageCount} handleAlertClick={handleAlertClick} tag={tag} />
    }
  }

  return results
}

MyScpAlerts.propTypes = {
  data: PropTypes.object,
  tag: PropTypes.func,
  handleAlertClick: PropTypes.func
}

export default MyScpAlerts
